import { Button } from '@nxtvid/component-library';
import './InboxTopPanel.css';
const InboxTopPanel = ({userInfo, selectedChatSession}) => {

    const handleToggleMenu = () => {
        // Function to handle toggling the menu
        // This function can be used to close the chat session or navigate back
        document.getElementsByClassName('inbox-left-panel')[0].classList.toggle('inbox-left-panel--hidden');
    }

    return(
        <div className = 'inbox-top-panel'>
            <div className = 'inbox-top-panel__title'>
                <div className='inbox-top-panel__back-button'>
                    <Button
                        type='ghost'
                        size='small'
                        label='<-'
                        onClick ={() => handleToggleMenu()}
                    />
                </div>
                <div className='profile-pic'>
                    {
                        //either return the profile pic or the initials of the user being messaged
                        selectedChatSession ?
                        selectedChatSession.videographerId === userInfo._id ?
                        selectedChatSession.clientProfilePic ?
                        <img src={selectedChatSession.clientProfilePic} alt='Client Profile' className='profile-pic__image' /> :
                        <div className='profile-pic__image'>
                            {selectedChatSession.clientName?.charAt(0)}
                        </div>
                        :
                        selectedChatSession.videographerProfilePic ?
                        <img src={selectedChatSession.videographerProfilePic} alt='Videographer Profile' className='profile-pic__image' />
                        :
                        <div className='profile-pic__image'>
                            {selectedChatSession.videographerName?.charAt(0)}
                        </div>
                        :
                        <div className='profile-pic__initials'>
                            {selectedChatSession ? selectedChatSession.videographerId === userInfo._id ? selectedChatSession.clientName?.charAt(0) : selectedChatSession.videographerName?.charAt(0) : 'S'}
                        </div>
                    }
                </div>
                <div className = 'inbox-top-panel__title-text'>{
                selectedChatSession ? selectedChatSession.videographerId === userInfo._id ? selectedChatSession?.clientName?.split(' ')[0] + " from " + selectedChatSession?.clientCompany : selectedChatSession?.videographerName?.split(' ')[0] + " from " + selectedChatSession?.videographerCompany : 'Select a chat session'
                }</div>
            </div>
            <div className = 'inbox-top-panel__details'>
                {selectedChatSession ? selectedChatSession.title : ''}
            </div>
        </div>
    )
}
export default InboxTopPanel;